import {
	createDefaultAudioLibraryItem,
	getAudioLibraryAudioUrl,
	getAudioLibraryCoverUrl,
	getAudioLibraryItemName,
	normalizeAudioLibraryData,
	normalizeAudioLibraryItem,
} from './audioLibrary.js';
import {
	getPayMediaUnlockKey,
	isPayMediaUnlocked,
	normalizePayMediaPriceFields,
	setPayMediaUnlocked,
} from './payMediaCommon.js';
import { LOCAL_ASSET } from './localAssets.js';

export const PAY_AUDIO_PLAYLIST_TYPE = 'pay-audio-playlist';
const UNLOCK_PREFIX = 'pay-audio-playlist';
export const PAY_AUDIO_PLAYLIST_VISIBLE_COUNT = 5;
export const PAY_AUDIO_PLAYLIST_COMPACT_FREE_COUNT = 1;
export const PAY_AUDIO_PLAYLIST_COMPACT_MAX_ITEMS = 5;

const PLAYLIST_PRESETS = LOCAL_ASSET.payAudioPlaylist || [];

export function createDefaultPayAudioPlaylistItems(count = PLAYLIST_PRESETS.length || 9) {
	const items = [];
	const total = Math.max(0, count);
	for (let i = 0; i < total; i += 1) {
		const preset = PLAYLIST_PRESETS[i] || PLAYLIST_PRESETS[i % PLAYLIST_PRESETS.length] || {};
		const item = createDefaultAudioLibraryItem(preset, i);
		if (preset.cover) {
			item.cover.previewUrl = preset.cover;
			item.cover.filename = preset.coverFilename || item.cover.filename;
			item.cover.url = '';
			item.cover.local = false;
		}
		if (preset.audio) {
			item.audio.url = preset.audio;
			item.audio.previewUrl = '';
			item.audio.filename = preset.filename || item.audio.filename;
			item.audio.local = false;
		}
		items.push(item);
	}
	return items;
}

export function getPayAudioPlaylistDefaults(extra = {}) {
	return normalizePayAudioPlaylistData({
		items: createDefaultPayAudioPlaylistItems(),
		title: '精选歌单',
		listTitle: '完整歌单',
		artist: 'Budiarti',
		payDesc: '永久播放',
		price: '29.90',
		buttonText: '解锁歌单',
		freePreviewCount: 1,
		...extra,
	});
}

export function normalizePayAudioPlaylistData(data = {}) {
	const sourceItems = Array.isArray(data.items) && data.items.length
		? data.items.map((item, index) => normalizeAudioLibraryItem(item, index))
		: createDefaultPayAudioPlaylistItems();
	const base = normalizeAudioLibraryData({
		...data,
		items: sourceItems,
	});
	const payFields = normalizePayMediaPriceFields(data, {
		defaultPrice: '29.90',
		defaultButtonText: '解锁歌单',
		maxPreviewCount: base.items.length,
	});
	return {
		...base,
		...payFields,
		items: sourceItems,
		title: data.title || '精选歌单',
		listTitle: data.listTitle || '完整歌单',
		artist: data.artist || 'Budiarti',
		payDesc: data.payDesc || '永久播放',
	};
}

export function isPayAudioPlaylistBlock(type) {
	return type === PAY_AUDIO_PLAYLIST_TYPE;
}

export {
	getAudioLibraryAudioUrl,
	getAudioLibraryCoverUrl,
	getAudioLibraryItemName,
};

export function getPayAudioPlaylistUnlockKey(blockId) {
	return getPayMediaUnlockKey(blockId, UNLOCK_PREFIX);
}

export function isPayAudioPlaylistUnlocked(blockId) {
	return isPayMediaUnlocked(blockId, UNLOCK_PREFIX);
}

export function setPayAudioPlaylistUnlocked(blockId, unlocked = true) {
	setPayMediaUnlocked(blockId, UNLOCK_PREFIX, unlocked);
}

export function getPayAudioPlaylistListEntries(data = {}, { unlocked = false, compact = false } = {}) {
	const normalized = normalizePayAudioPlaylistData(data);
	const pageCount = normalized.items.length;
	const freeCount = compact
		? Math.min(PAY_AUDIO_PLAYLIST_COMPACT_FREE_COUNT, normalized.freePreviewCount, pageCount)
		: normalized.freePreviewCount;
	const displayItems = compact
		? normalized.items.slice(0, PAY_AUDIO_PLAYLIST_COMPACT_MAX_ITEMS)
		: normalized.items;

	return displayItems.map((item, index) => ({
		key: item.id,
		item,
		index,
		locked: unlocked ? false : index >= freeCount,
	}));
}

export function getPayAudioPlaylistPreviewDefaults() {
	return normalizePayAudioPlaylistData({
		items: createDefaultPayAudioPlaylistItems(),
		freePreviewCount: 1,
	});
}

export function getAudioTrackTitle(item) {
	const name = getAudioLibraryItemName(item) || '';
	return name.replace(/\.[^.]+$/, '') || name || '未命名音频';
}

export function formatAudioTime(seconds = 0) {
	const total = Math.max(0, Math.floor(Number(seconds) || 0));
	const mins = Math.floor(total / 60);
	const secs = total % 60;
	return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}
